import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addNewTransaction, deleteTransaction, setSelectedTranscations, updateAllTransactions, updateTransaction, updateTransactionDetailsModalDetails, updateTransactionDetailsModalStatus, updateTransactionModalStatus, updateTransactionSearchParams, updateTransactionsLoadingStatus, updateTransactionsPagination, updateTransactionsSearch, updateTransactionTriggerTranscationsRefresh, useReturnAllTransactions, useReturnTransactionsLoadingStatus, useReturnTransactionsPagination, useReturnTransactionsSearch } from './transactionsSlice'
import TransactionsApp, { ITransactionModal, transactionsActionsList, transactionsTypesList } from './TransactionsApp'
import { ISearchParam } from '../BaseApp'
import { handleRequestError } from '../../services/api'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { IAxiosDefaultDataObject } from '../../config'
import { IDataDisplayerHeaderOptionActionButton, IDataDisplyerItemActionOption } from '../../components/DataDisplayer/DataDisplayer'
import { IDynamicForm } from '../../components/Form/DynamicForm'
import AdminDynamicBasePage from '../admin/AdminDynamicBasePage'
import NewTransactionModel from './NewTransactionModel'
import { useReturnCurrentPageType } from '../admin/adminPagesSlice'
import { createOrUpdateElementData } from '../../components/Form/formsSlice'
import { addNewItem, useReturnAllItems } from '../items/itemsSlice'
import ItemsApp from '../items/ItemsApp'
import { useReturnCurrentUser } from '../user/userSlice'
import { addNewProject, useReturnAllProjects } from '../projects/projectsSlice'
import ProjectsApp from '../projects/ProjectsApp'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { useReturnSingleDispplayer } from '../../components/DataDisplayer/dataDisplyerSlice'
import TransactionDetailsModal from './TransactionDetailsModal'
import { Button } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import GridData from '../../components/GridData/GridData'
import { ICellRendererParams } from 'ag-grid-community'
import GenerateTransactionDestination from './GenerateTransactionDestination'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import PageHeadSection from '../admin/components/PageHeadSection'
import UsersApp from '../user/UsersApp'
import ItemsRequestsApp from '../items_requests/ItemsRequestsApp'

interface IProps {
    itemId?: number,
    hidePageHeadSection?: boolean,
    itemContained?: boolean,
    noSectionBoxWrap?: boolean
}

export default function TransactionsList(props: IProps) {

    const { itemId, hidePageHeadSection , itemContained, noSectionBoxWrap } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { modalOpenStatus, triggerTranscationsRefresh, selectedTransactions, searchParams } = useSelector((state: RootState) => state.transactions)

    // const [showNewTransactionModel, setShowNewTransactionModel] = useState<boolean>(false)

    const pageType = useReturnCurrentPageType()
    const transactionsList = useReturnAllTransactions()

    const transactions = useReturnAllTransactions()
    const pagination = useReturnTransactionsPagination()
    const loading = useReturnTransactionsLoadingStatus()
    const search = useReturnTransactionsSearch()

    const transactionsApp = new TransactionsApp()
    const currentUser = useReturnCurrentUser()

    // const dataDisplayer = useReturnSingleDispplayer("transactions_displayer")

    /**
     * Handle Update Modal Open status
     */
    const handleUpdateModalOpenStatus = (status: boolean) => dispatch(updateTransactionModalStatus(status))

    /**
     * Update loading status
     */
    const updateLoadingStatus = (status: boolean) => dispatch(updateTransactionsLoadingStatus({ loading: status }))

    /**
     * Load items
     */
    // const loadTransactions = (page: number, search: string|null, disablePagination: boolean, addItems?: boolean, searchParams?: Array<ISearchParam>) => {
    //     updateLoadingStatus(true)


    //     let load = transactionsApp.listOfInstances(page, search, disablePagination, addItems, searchParams)

    //     if (itemId){
    //         load = transactionsApp.listOfInstancesForItem(itemId, page, search, disablePagination, addItems, searchParams)
    //     }

    //     load
    //         .then(response => {

    //             const { data } = response
    //             const results: Array<ITransactionModal> = disablePagination ? data : data.results

    //             if (addItems){
    //                 results.map((singleItem) => dispatch(addNewTransaction(singleItem)))
    //             }else{
    //                 dispatch(updateAllTransactions([]))
    //                 dispatch(updateAllTransactions(results))
    //             }
    
                
    //             if (!disablePagination){
    //                 dispatch(updateTransactionsPagination({
    //                     count: data.count,
    //                     current_page: page,
    //                     total_pages: data.total_pages
    //                 }))
    //             }else{
    //                 dispatch(updateTransactionsPagination({
    //                     count: results.length,
    //                     current_page: 1,
    //                     total_pages: 1
    //                 }))
    //             }

    //             updateLoadingStatus(false)

    //         })
    //         .catch(error => {

    //             handleRequestError(error, dispatch)
    //             updateLoadingStatus(false)

    //         })
    // }

    /**
     * Load transcations
     */
    const loadTransactions = (page: number, search: string|null, disablePagination: boolean, addItems?: boolean, searchParams?: Array<ISearchParam>) => {
        return itemId ? transactionsApp.itemTransactionsList(itemId, page, search, disablePagination, addItems, searchParams) : transactionsApp.listOfInstances(page, search, disablePagination, addItems, searchParams)
    }

    /**
     * Delete transcation
     */
    const handleDeleteTransaction = (id: number) => {

        updateLoadingStatus(true)

        transactionsApp.deleteInstance(id)
            .then(response => {
                updateLoadingStatus(false)

                dispatch(deleteTransaction({ id: id }))
                dispatch(updateTransactionsPagination({
                    ...pagination,
                    count: pagination.count - 1
                }))

                updateQuickNotificationDetails(true, "Done!", "success", dispatch)
            })
            .catch(error => {
                updateLoadingStatus(false)
                handleRequestError(error, dispatch)
            })

    }

    /**
     * Handle delete many transcations
     */
    const handleDeleteManyTransactions = (records: Array<IAxiosDefaultDataObject>) => {
        updateLoadingStatus(true)

        transactionsApp.deleteManyInstances(records)
            .then(response => {
                updateLoadingStatus(false)

                
                records.map((record) => {
                    dispatch(deleteTransaction({ id: record.id }))
                })

                dispatch(updateTransactionsPagination({
                    ...pagination,
                    count: pagination.count - records.length
                }))

                updateQuickNotificationDetails(true, "Done!", "success", dispatch)
            })
            .catch(error => {
                updateLoadingStatus(false)
                handleRequestError(error, dispatch)
            })   
    }

    /**
     * Handle update search
     */
    const handleUpdateSearch = (search: string) => dispatch(updateTransactionsSearch({ search: search }))

    /**
     * Show details modal
     */
    const handleShowTranscationDetailsModal = (transcation: ITransactionModal) => {
        dispatch(updateTransactionDetailsModalStatus(true))
        dispatch(updateTransactionDetailsModalDetails(transcation))
    }

    /**
     * actions
     */
    const itemActionOptions: Array<IDataDisplyerItemActionOption> = [
        // {
        //     icon: "edit",
        //     label: "Edit",
        //     onClick: (rawItem) => {
        //         navigate("/panel/items/edit/" + rawItem.id)
        //     },
        // },
        {
            icon: "show",
            label: "Details",
            onClick: (rawItem) => {
                handleShowTranscationDetailsModal((rawItem as ITransactionModal))
            },
        },
    ]

    /**
     * Filter Form
     */
    const filterForm: IDynamicForm = {
        name: "transactions-data-displayer-filter-form",
        elements: [
            {
                id: "type",
                xs: 4,
                type: "Select",
                label: "Type",
                fullWidth: true,
                displayForItem: true,
                addNoneItem: true,
                items: transactionsTypesList
            },
            {
                id: "action",
                xs: 4,
                type: "Select",
                label: "Action",
                fullWidth: true,
                displayForItem: true,
                addNoneItem: true,
                items: transactionsActionsList
            },
            {
                id: "item_id",
                xs: 4,
                type: "DynamicModelSelect",
                label: "Item",
                fullWidth: true,
                appClass: new ItemsApp(),
                selectLabel: "Select Item",
                gridColumns: new ItemsApp().gridDataColumns
            },
            {
                id: "user_id",
                xs: 6,
                type: "DynamicModelSelect",
                label: "User",
                fullWidth: true,
                appClass: new UsersApp(),
                selectLabel: "Select User",
                gridColumns: new UsersApp().gridDataColumns
            },
            {
                id: "project_id",
                xs: 6,
                type: "DynamicModelSelect",
                label: "Project",
                fullWidth: true,
                appClass: new ProjectsApp(),
                selectLabel: "Select Project",
                gridColumns: new ProjectsApp().gridDataColumns
            },
        ]
    }

    /**
     * Load 
     */
    useEffect(() => {
        
        if (props.itemId){

            let transactionsToDelete: Array<number> = []

            transactionsList.map((trans) => {
                if (trans.item_id !== props.itemId){
                    transactionsToDelete.push(trans.id)
                }
            })

            transactionsToDelete.map((del) => dispatch(deleteTransaction({ id: del })))

        }

    }, [props.itemId, transactionsList])

    /**
     * Refresh transcations
     */
    useEffect(() => {
        if (triggerTranscationsRefresh){
            dispatch(updateTransactionTriggerTranscationsRefresh(false))

            // loadTransactions(1, dataDisplayer.search ? dataDisplayer.search : "", false, false, dataDisplayer.searchParamsList)
            loadTransactions(1, "", false, false, [])
        }
    }, [triggerTranscationsRefresh])

    /**
     * Hide new modal
     */
    const hideNewTransactionModal = () => handleUpdateModalOpenStatus(false)

    return(
        <>
            <NewTransactionModel itemId={itemId} shown={modalOpenStatus} handleClose={hideNewTransactionModal} />
            <TransactionDetailsModal />

            {!hidePageHeadSection && <PageHeadSection pageName="transactions" customActionButtons={[
                  {
                    icon: "new",
                    label: "New Transaction",
                    onClick: () => handleUpdateModalOpenStatus(true),
                    // customContent: (button, selectedItems) => {

                    //     return <Button disabled={itemContained ? true : false} className="general-button admin-style" onClick={() => handleUpdateModalOpenStatus(true)} startIcon={<GenerateIcon icon="new" />}>Add new</Button>
                    // },
                }
            ]} />}

            <SectionBoxContainer noWrap={noSectionBoxWrap ? true : false}>
                <GridData 
                    items={transactions}
                    columns={[
                        {
                            field: "action",
                            headerName: "Action",
                            type: "status",
                            width: 180,
                        },
                        {
                            field: "type",
                            headerName: "Type",
                            type: "status",
                            width: 180,
                        },
                        {
                            field: "item_title",
                            headerName: "Item",
                            type: "quick-preview",
                            width: 200,
                            minWidth: 200,
                            cellRendererParams: {
                                appClass: () => new ItemsApp(),
                                elemIdTitle: "item_id",
                            }
                        },
                        // {
                        //     field: "item_title",
                        //     headerName: "Item",
                        //     cellRenderer: (params: ICellRendererParams<ITransactionModal>) => {
                        //         if (!params.data){
                        //             return params.value
                        //         }

                        //         return <a className="data-grid-link" target='_blank' href={"/panel/items/view/" + params.data.item_id}><h3 className="title">{params.value}</h3></a>
                        //     }
                        // },
                        {
                            field: "project_title",
                            headerName: "Project",
                            type: "quick-preview",
                            cellRendererParams: {
                                appClass: () => new ProjectsApp(),
                                elemIdTitle: "project_id",
                            }
                        },
                        {
                            field: "request_ref",
                            headerName: "Request Ref.",
                            // cellRenderer: (params: ICellRendererParams<ITransactionModal>) => {
                            //     if (!params.data){
                            //         return params.value
                            //     }

                            //     if (params.data.request_ref){
                            //         return <a className="data-grid-link" target='_blank' href={"/panel/item_requests/view/" + params.data.request_ref}><h3 className="title">{params.value}</h3></a>
                            //     }

                            //     return "-"
                            // }
                            type: "quick-preview",
                            cellRendererParams: {
                                appClass: () => new ItemsRequestsApp(),
                                elemIdTitle: "request_ref",
                                customViewLink: "/panel/item_requests/view/[request_ref]"
                            }
                        },
                        {
                            field: "warehouse_title",
                            headerName: "Destination",
                            width: 350,
                            cellRenderer: (params: ICellRendererParams<ITransactionModal>) => {
                                return <GenerateTransactionDestination transcation={(params.data as ITransactionModal)} />
                            }
                        },
                        {
                            field: "warehouse_title",
                            headerName: "Origin",
                            width: 350,
                            cellRenderer: (params: ICellRendererParams<ITransactionModal>) => {
                                return <GenerateTransactionDestination transcation={(params.data as ITransactionModal)} showOrigin />
                            }
                        },
                        {
                            field: "quantity",
                            headerName: "Quantity",
                            width: 100,
                            cellRenderer: (params: ICellRendererParams<ITransactionModal>) => {
                                let addSymbol: string = ""
                                if (params.data){
                                    const type = params.data.type
                                    const action = params.data.action

                                    if (type == "stock-adjustment"){
                                        if (action == "new-item"){
                                            addSymbol = "+"
                                        }
                                        if (action == "reduce-stock"){
                                            addSymbol = "-"
                                        }
                                    }
                                }

                                return addSymbol + params.value
                            }
                        },
                        {
                            field: "created_by_name",
                            headerName: "User",
                            width: 200,
                            type: "quick-preview",
                            cellRendererParams: {
                                appClass: () => new UsersApp(),
                                elemIdTitle: "user_id",
                            }
                        },
                        {
                            field: "timestamp",
                            headerName: "Timestamp",
                            width: 250,
                            type: "date",
                        },
                    ]}
                    selectedItems={selectedTransactions}
                    pagination={pagination}
                    search={search ? search : ""}
                    searchParams={searchParams}
                    loading={loading}
                    actionButtons={[
                        {
                            icon: "show",
                            isIconButton: true,
                            onClick(data, dispatch, navigate) {
                                handleShowTranscationDetailsModal((data as ITransactionModal))
                            },
                        },
                        {
                            icon: "delete",
                            color: "error",
                            isIconButton: true,
                            onClick(data, dispatch, navigate) {
                                handleDeleteTransaction(data.id)
                            },
                        }
                    ]}
                    headerOptions={[
                        {
                            label: "Add new",
                            icon: "new",
                            onClick: () => {},
                            customButton(selectedItems, updateFilterShowStatus, deleteItem, deleteManyItems, refresh, filterShownStatus) {
                                return <Button disabled={false} className="general-button admin-style" onClick={() => handleUpdateModalOpenStatus(true)} startIcon={<GenerateIcon icon="new" />}>Add new</Button>
                                // return <Button disabled={itemContained ? true : false} className="general-button admin-style" onClick={() => handleUpdateModalOpenStatus(true)} startIcon={<GenerateIcon icon="new" />}>Add new</Button>
                            }
                        }
                    ]}
                    handleLoadItems={loadTransactions}
                    updateSearch={(search) => dispatch(updateTransactionsSearch({ search: search }))}
                    setSelectedItems={(items) => dispatch(setSelectedTranscations(items))}
                    onDeleteItem={transactionsApp.deleteInstance}
                    onDeleteManyItems={transactionsApp.deleteManyInstances}
                    deleteItem={(id, dispatch) => dispatch(deleteTransaction({ id: id }))}
                    updateLoading={updateLoadingStatus}
                    updateItemSearchParams={(params) => dispatch(updateTransactionSearchParams(params))}
                    addNewItem={(item, dispatch) => dispatch(addNewTransaction(item))}
                    updateItem={(item, dispatch) => dispatch(updateTransaction(item))}
                    updateAllItems={(items, dispatch) => dispatch(updateAllTransactions(items))}
                    updateItemsPagination={(pagination, dispatch) => dispatch(updateTransactionsPagination(pagination))}
                    config={{
                        viewItemLink: "/panel/transactions/view/[id]",
                        editItemLink: "/panel/transactions/edit/[id]",
                        filterForm: filterForm,
                        rowHeight: 50,
                    }}
                    updateSearchParamsBeforeLoadItems={(params) => {
                        if (!itemId){
                            return params
                        }

                        return [
                            ...params,
                            {
                                name: "item_id",
                                value: itemId
                            }
                        ]
                    }}
                />
            </SectionBoxContainer>
{/* 
            <AdminDynamicBasePage 
                appClass={transactionsApp}
                itemsList={transactions}
                pagination={pagination}
                loading={loading}
                search={search}
                updateLoadingStatus={updateLoadingStatus}
                loadItems={loadTransactions}
                deleteItem={handleDeleteTransaction}
                deleteManyItems={handleDeleteManyTransactions}
                updateSearch={handleUpdateSearch}
                itemsActionOptions={itemActionOptions}
                filterForm={filterForm}
                hidePageHeadSection={hidePageHeadSection ? hidePageHeadSection : pageType == "base" ? false : true}
                customHeaderOptionActionButtons={[
                    {
                        icon: "new",
                        label: "Add new",
                        onClick: () => {},
                        customContent: (button, selectedItems) => {

                            return <Button disabled={itemContained ? true : false} className="general-button admin-style" onClick={() => handleUpdateModalOpenStatus(true)} startIcon={<GenerateIcon icon="new" />}>Add new</Button>
                        },
                    }
                ]}  
                disableSearch={true}
                customPageHeadSectionActionButtons={[]}
            /> */}
        </>
    )
}